export default {
  path: ":alias/votes",
  component: resolve => require(["@/views/votes"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/votes/list"], resolve)
    }
  ]
};
